module.exports = __webpack_public_path__ + "img/s.c56f769f.gif";